import React from 'react';
import './styles/App.css';
import { Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import PrivacyPage from './pages/privacy';
import HomePage from './components/Home';
import { Box } from '@mui/material';



function PlataeaStudios() {

  return (
    <div className="App">
      <header className="banner">
        <Box
          component={'img'}
          sx={{
            height: "12rem"
          }}
          alt={'The Plataea Studios company logo'}
          src={'./images/Plataea_horizontal_white_text.svg'}
        />
      </header>
      <Layout />
      <Routes>
        <Route path="/" element={<HomePage />}/>
        <Route path="/privacy" element={<PrivacyPage />} />
      </Routes>
    </div>
  );
}

export default PlataeaStudios;
